import type { StockCommandV1 } from '@trackeat/shared';
import { openLocalDb } from '../db/local.js';

/** New metadata actions must not reuse a known archived DDT. Historical
 * stock events retain their source document; persisted envelopes replay intact. */
export async function prepareNewLotStateCommand(command: StockCommandV1): Promise<StockCommandV1> {
  if (command.movement_class !== 'lot_state') return command;
  const documentIds = [...new Set(command.lines.flatMap((line) => line.document_id ? [line.document_id] : []))];
  if (documentIds.length === 0) return command;
  const db = await openLocalDb(null);
  const result = await db.query(
    `SELECT id FROM masters_local
      WHERE table_name = 'documents' AND tenant_id = ? AND archived = 1
        AND id IN (${documentIds.map(() => '?').join(',')})
        AND NOT EXISTS (SELECT 1 FROM pending_stock_commands WHERE command_id = ?)`,
    [command.tenant_id, ...documentIds, command.command_id],
  );
  const archived = new Set((result.values ?? []).map((row) => row.id));
  if (archived.size === 0) return command;
  return { ...command, lines: command.lines.map((line) =>
    line.document_id && archived.has(line.document_id) ? { ...line, document_id: null } : line) };
}
